import _toConsumableArray from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// src/shared/db.ts
import Dexie from "dexie";
import * as R from "ramda";

var ChatroomsDatabase = /*#__PURE__*/function (_Dexie) {
  _inherits(ChatroomsDatabase, _Dexie);

  var _super = _createSuper(ChatroomsDatabase);

  function ChatroomsDatabase() {
    var _this;

    _classCallCheck(this, ChatroomsDatabase);

    _this = _super.call(this, "ChatroomsDatabase");

    _this.version(1).stores({
      messages: null
    }).upgrade( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(tx) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return tx.table("messages").clear();

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    _this.version(2).stores({
      messages: "[chatRoomId+_id],time,isTemp",
      chatrooms: "_id"
    }).upgrade( /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(tx) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return tx.table("messages").clear();

              case 2:
                _context2.next = 4;
                return tx.table("chatrooms").clear();

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }());

    _this.version(3).stores({
      messages: "[chatRoomId+_id],time,isTemp",
      chatrooms: "_id"
    }).upgrade( /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(tx) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return tx.table("messages").clear();

              case 2:
                _context3.next = 4;
                return tx.table("chatrooms").clear();

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }());

    _this.version(4).stores({
      messages: "[chatRoomId+_id],time,isTemp",
      chatrooms: "_id",
      suggestions: "[chatRoomId+_id],time"
    }).upgrade( /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(tx) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return tx.table("messages").clear();

              case 2:
                _context4.next = 4;
                return tx.table("chatrooms").clear();

              case 4:
                _context4.next = 6;
                return tx.table("suggestions").clear();

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x4) {
        return _ref4.apply(this, arguments);
      };
    }());

    return _this;
  }

  _createClass(ChatroomsDatabase, [{
    key: "addChatroom",
    value: function addChatroom(chatRoomId) {
      return this.chatrooms.add({
        _id: chatRoomId,
        isReady: false,
        updated_at: /* @__PURE__ */new Date()
      });
    }
  }, {
    key: "updateChatroom",
    value: function updateChatroom(chatRoomId, payload) {
      return this.chatrooms.update(chatRoomId, payload);
    }
  }, {
    key: "upsertChatroom",
    value: function upsertChatroom(chatRoomId, payload) {
      return this.chatrooms.put(_objectSpread(_objectSpread({}, payload), {}, {
        _id: chatRoomId,
        updated_at: /* @__PURE__ */new Date()
      }));
    }
  }, {
    key: "getChatroom",
    value: function getChatroom() {
      var chatRoomId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      return this.chatrooms.get({
        _id: chatRoomId
      });
    }
  }, {
    key: "addMessage",
    value: function addMessage(data) {
      return this.messages.add(_objectSpread(_objectSpread({}, data), {}, {
        isTemp: 0
      }));
    }
  }, {
    key: "addTempMessage",
    value: function addTempMessage(data) {
      return this.messages.add(_objectSpread(_objectSpread({}, data), {}, {
        isTemp: 1
      }));
    }
  }, {
    key: "addSuggestion",
    value: function addSuggestion(payload) {
      return this.suggestions.add({
        _id: payload._id,
        originMessage: payload,
        text: payload.text || "",
        reply: "",
        chatRoomId: payload.chatRoomId,
        isReady: false,
        time: /* @__PURE__ */new Date().toISOString(),
        rated: false
      });
    }
  }, {
    key: "updateSuggestion",
    value: function updateSuggestion(key, payload) {
      return this.suggestions.update(key, payload);
    }
  }, {
    key: "upsertSuggestion",
    value: function upsertSuggestion(_id, payload) {
      return this.suggestions.put({
        originMessage: payload,
        text: payload.text || "",
        reply: "",
        chatRoomId: payload.chatRoomId,
        time: /* @__PURE__ */new Date().toISOString(),
        isReady: false,
        rated: false,
        _id: _id
      });
    }
  }, {
    key: "updateSuggestionRating",
    value: function updateSuggestionRating(key, payload) {
      return this.suggestions.update(key, {
        rating: payload.rating,
        editedReply: payload.editedReply,
        comment: payload.comment,
        rated: true
      });
    }
  }, {
    key: "getTempMessages",
    value: function getTempMessages() {
      var chatRoomId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

      if (!chatRoomId) {
        return this.messages.where({
          isTemp: 1
        }).sortBy("time");
      }

      return this.messages.where({
        chatRoomId: chatRoomId
      }).and(function (message) {
        return !!message.isTemp;
      }).sortBy("time");
    }
  }, {
    key: "getSuggestions",
    value: function getSuggestions() {
      var chatRoomId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      return this.suggestions.where({
        chatRoomId: chatRoomId
      }).sortBy("time");
    }
  }, {
    key: "clearSuggestions",
    value: function clearSuggestions() {
      var chatRoomId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      return this.suggestions.where({
        chatRoomId: chatRoomId
      })["delete"]();
    }
  }, {
    key: "clearMessages",
    value: function clearMessages() {
      var chatRoomId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      return this.messages.where({
        chatRoomId: chatRoomId
      })["delete"]();
    }
  }, {
    key: "clearTempMessages",
    value: function clearTempMessages() {
      var chatRoomId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      return this.messages.where({
        chatRoomId: chatRoomId
      }).and(function (message) {
        return !!message.isTemp;
      })["delete"]();
    }
  }, {
    key: "addMessages",
    value: function addMessages(data, chatRoomId) {
      return this.messages.bulkPut(R.map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          chatRoomId: chatRoomId,
          isTemp: 0
        });
      }, data));
    }
  }, {
    key: "getMessageById",
    value: function getMessageById() {
      var chatRoomId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      return this.messages.where("[chatRoomId+_id]").equals([chatRoomId, id]).last();
    }
  }, {
    key: "getMessages",
    value: function () {
      var _getMessages = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var chatRoomId,
            limit,
            tempMessages,
            messages,
            _args5 = arguments;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                chatRoomId = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : "";
                limit = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : Infinity;
                _context5.next = 4;
                return this.getTempMessages(chatRoomId);

              case 4:
                tempMessages = _context5.sent;
                _context5.next = 7;
                return this.messages.where({
                  chatRoomId: chatRoomId
                }).and(function (message) {
                  return !message.isTemp;
                }).limit(limit).reverse().toArray();

              case 7:
                messages = _context5.sent;
                return _context5.abrupt("return", [].concat(_toConsumableArray(tempMessages.reverse()), _toConsumableArray(messages)));

              case 9:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getMessages() {
        return _getMessages.apply(this, arguments);
      }

      return getMessages;
    }()
  }, {
    key: "getMessagesCenteredAround",
    value: function () {
      var _getMessagesCenteredAround = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var messageId,
            chatRoomId,
            limit,
            message,
            messagesPerSide,
            messagesBefore,
            messagesAfter,
            tempMessages,
            centeredMessages,
            _args6 = arguments;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                messageId = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : "";
                chatRoomId = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : "";
                limit = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : 15;

                if (chatRoomId) {
                  _context6.next = 5;
                  break;
                }

                return _context6.abrupt("return", []);

              case 5:
                if (messageId) {
                  _context6.next = 7;
                  break;
                }

                return _context6.abrupt("return", this.getMessages(chatRoomId, limit));

              case 7:
                _context6.next = 9;
                return this.getMessageById(chatRoomId, messageId);

              case 9:
                message = _context6.sent;

                if (!(message && !message.isTemp)) {
                  _context6.next = 23;
                  break;
                }

                messagesPerSide = limit >>> 1;
                _context6.next = 14;
                return this.messages.where("[chatRoomId+_id]").between([chatRoomId, Dexie.minKey], [chatRoomId, messageId], true, true).and(function (message2) {
                  return !message2.isTemp;
                }).reverse().limit(messagesPerSide).toArray();

              case 14:
                messagesBefore = _context6.sent;
                _context6.next = 17;
                return this.messages.where("[chatRoomId+_id]").between([chatRoomId, messageId], [chatRoomId, Dexie.maxKey], false, true).and(function (message2) {
                  return !message2.isTemp;
                }).limit(messagesPerSide).toArray();

              case 17:
                messagesAfter = _context6.sent;
                _context6.next = 20;
                return this.getTempMessages(chatRoomId);

              case 20:
                tempMessages = _context6.sent;
                centeredMessages = [].concat(_toConsumableArray(tempMessages.reverse()), _toConsumableArray(messagesAfter.reverse()), _toConsumableArray(messagesBefore));
                return _context6.abrupt("return", centeredMessages);

              case 23:
                return _context6.abrupt("return", this.getMessages(chatRoomId, limit));

              case 24:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getMessagesCenteredAround() {
        return _getMessagesCenteredAround.apply(this, arguments);
      }

      return getMessagesCenteredAround;
    }()
  }, {
    key: "getFirstMessage",
    value: function () {
      var _getFirstMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(chatRoomId) {
        var messages;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (chatRoomId) {
                  _context7.next = 2;
                  break;
                }

                return _context7.abrupt("return");

              case 2:
                _context7.next = 4;
                return this.getMessages(chatRoomId);

              case 4:
                messages = _context7.sent;
                return _context7.abrupt("return", R.last(messages));

              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getFirstMessage(_x5) {
        return _getFirstMessage.apply(this, arguments);
      }

      return getFirstMessage;
    }()
  }, {
    key: "getLastMessage",
    value: function () {
      var _getLastMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(chatRoomId) {
        var messages;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (chatRoomId) {
                  _context8.next = 2;
                  break;
                }

                return _context8.abrupt("return");

              case 2:
                _context8.next = 4;
                return this.getMessages(chatRoomId);

              case 4:
                messages = _context8.sent;
                return _context8.abrupt("return", R.head(messages));

              case 6:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function getLastMessage(_x6) {
        return _getLastMessage.apply(this, arguments);
      }

      return getLastMessage;
    }()
  }, {
    key: "getClosestMessageByTime",
    value: function () {
      var _getClosestMessageByTime = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(chatRoomId, time) {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (!(!chatRoomId || !time)) {
                  _context9.next = 2;
                  break;
                }

                return _context9.abrupt("return");

              case 2:
                return _context9.abrupt("return", this.messages.where({
                  chatRoomId: chatRoomId
                }).filter(function (message) {
                  return message.time >= time && !message.isTemp;
                }).first());

              case 3:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function getClosestMessageByTime(_x7, _x8) {
        return _getClosestMessageByTime.apply(this, arguments);
      }

      return getClosestMessageByTime;
    }()
  }]);

  return ChatroomsDatabase;
}(Dexie);

export { ChatroomsDatabase };